import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '@xo-union/tk-component-icons';
import OutsideClickHandler from '@xo-union/component-outside-click';
import GuestStatus from '~/glm/components/shared/guest-status';
import styles from './select-dropdown.scss';

const dotColor = {
  Invited: '#fbb559',
  Attending: '#75cdc0',
  Declined: '#dc5899',
};

export default class SelectDropdown extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node,
    setMenuState: PropTypes.func,
    selectedFilterData: PropTypes.string,
    menuOpen: PropTypes.bool,
  };

  displayFilterType = filterValue => {
    const color = dotColor[filterValue];
    return (
      <div>
        <GuestStatus color={color} label={filterValue} />
      </div>
    );
  };

  render() {
    const { label, selectedFilterData, setMenuState, menuOpen, children } = this.props;
    return (
      <OutsideClickHandler onOutsideClick={() => setMenuState(false)}>
        <div className={styles.menuDropdown}>
          <button tabIndex="0" className={styles.fauxInput} onClick={setMenuState}>
            {selectedFilterData ? this.displayFilterType(selectedFilterData) : label}
            {menuOpen ? <Icon name={'caret_up'} size="md" /> : <Icon name={'caret_down'} size="md" />}
          </button>
          {menuOpen && children}
        </div>
      </OutsideClickHandler>
    );
  }
}
